module.exports = __webpack_public_path__ + "media/images/faq/2-100-8a0d930a8a7fd9f30d50f07779fc303b.jpg";